export default __webpack_public_path__ + "static/media/quick-banner-mobile.f51c5c4f.png";